import Vue from 'vue'
import Vuex from 'vuex'
import { getDeviceInfo } from "@/api/device"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    deviceNo: '',
    phone: "未绑定",
    signals: "", // 信号强度
    onlineStatus: "", // 在线状态  1：在线 0：离线
    connectNumber: 0, // 设备连接数
    cardList: [], // 卡片列表
    userId: null, // 用户id
    orderedPackages: [], // 已订购套餐
  },
  getters: {
    // 存在生效的套餐
    hasEffectOrder: state => {
      return state.orderedPackages.some(pkg => pkg.status == 1)
    }
  },
  mutations: {
    SET_DEVICE_DATA(state, data) {
      state.deviceNo = data.deviceNo;
      state.phone = data.phone;
    },
    SET_ORDERED_PACKAGE(state, data) {
      state.orderedPackages = data;
    },
    SET_USER_ID(state, userInfo) {
      state.userId = userInfo.userId;
    }
  },
  actions: {
    // 初始化数据（刷新后调用：优先从 sessionStorage 恢复，否则重新请求）
    async initDeviceInfo({ commit, state }, deviceNo) {
      // 若 Vuex 中已有数据，直接返回
      // if (state.prevPageData) return;

      try {
        const res = await getDeviceInfo(deviceNo);
        if (res.code == '200') {
          const { mobile, imei } = res.data;
          commit('SET_DEVICE_DATA', { deviceNo: imei, phone: mobile });
        }

      } catch (err) {
        // commit('SET_ERROR', err.message || '数据请求失败');
      } finally {
        // commit('SET_LOADING', false);
      }
    },
    async fetchOrder({ commit, state }, deviceNo) {
      try {
        const res = await queryCardOrder(deviceNo);
        if (res.code == '200') {
          const { data } = res.data;
          commit('SET_ORDERED_PACKAGE', data);
        }
      } catch (err) {
        console.log(err.message || '数据请求失败');
      }
    }
  },
  modules: {
  }
})
